// extracted by mini-css-extract-plugin
export var chatHtmlText = "_oy-2";
export var chatLink = "_oy-0";
export var chatText = "_oy-1";